var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('gmap-map',{staticClass:"MAP",attrs:{"center":_vm.latlngs[0] || _vm.murica,"zoom":9}},_vm._l((_vm.latlngs),function(latlng,index){return _c('gmap-marker',{key:index,attrs:{"position":latlng,"icon":require('./assets/pin.svg')}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }